import {
	OPEN_UPDATE_JIRA_DIALOG,
	type OpenDialogAction,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/ui/top/title-bar/update-jira/actions.tsx';
import { ENTITY } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import {
	START as COMMIT_START,
	type StartAction as CommitStartAction,
} from '../commit/actions.tsx';
import { ADD, REMOVE, type AddAction, type RemoveAction } from './actions.tsx';
import type { State } from './types.tsx';

type Action = AddAction | RemoveAction | CommitStartAction | OpenDialogAction;

const initialState: State = {
	[ENTITY.ISSUE]: {},
	[ENTITY.RELEASE]: {},
	[ENTITY.CROSS_PROJECT_RELEASE]: {},
	[ENTITY.TEAM]: {},
	[ENTITY.RESOURCE]: {},
	[ENTITY.SPRINT]: {},
	showWarningsOnNextOpen: false,
};

export const warnings = (state: State = initialState, action: Action): State => {
	switch (action.type) {
		case ADD: {
			const { category, itemId, warnings: warningsArray } = action.payload;

			return {
				...state,
				[category]: {
					...state[category],
					[itemId]: warningsArray,
				},
			};
		}
		case COMMIT_START: {
			if (fg('unblock_ui_during_committing_changes')) {
				return {
					...initialState,
					showWarningsOnNextOpen: true,
				};
			}
			return initialState;
		}
		case OPEN_UPDATE_JIRA_DIALOG: {
			if (state.showWarningsOnNextOpen && fg('unblock_ui_during_committing_changes')) {
				return {
					...state,
					showWarningsOnNextOpen: !!action.payload.isSaving,
				};
			}
			return initialState;
		}
		case REMOVE: {
			const { category, itemId } = action.payload;

			const newState = { ...state };
			delete newState[category]?.[itemId];

			return newState;
		}
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
